import { 
  CalendarIcon, 
  ScissorsIcon, 
  UsersIcon, 
  CurrencyDollarIcon, 
  Cog6ToothIcon, 
  BellIcon, 
  ChartBarIcon,
  UserPlusIcon
} from '@heroicons/react/24/outline';

export const navigationItems = [
  { 
    id: 'appointments', 
    name: 'Agenda', 
    icon: CalendarIcon,
    mobileVisible: true
  },
  { 
    id: 'confirmations', 
    name: 'Confirmações', 
    icon: BellIcon,
    mobileVisible: true
  },
  { 
    id: 'performance', 
    name: 'Desempenho', 
    icon: ChartBarIcon,
    mobileVisible: true
  },
  { 
    id: 'commission', 
    name: 'Comissões', 
    icon: CurrencyDollarIcon,
    mobileVisible: true
  },
  { 
    id: 'users', 
    name: 'Usuários', 
    icon: UserPlusIcon,
    description: 'Gerenciar usuários e convites',
    requiresPermission: true,
    mobileVisible: false
  },
  { 
    id: 'settings', 
    name: 'Configurações', 
    icon: Cog6ToothIcon,
    mobileVisible: true
  }
];

// Exportando os ícones para uso em outras partes do sistema
export const serviceIcon = ScissorsIcon;
export const professionalIcon = UsersIcon;
